import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import { messages } from '../PersonalContacts.i18n';
import history from '../../../history';

class AddContactButton extends React.Component {
  handleAddContactClick = () => {
    history.push('/add-contact');
  }

  render = () => {
    const { formatMessage } = this.props.intl;
    return (
      <div className="col">
        <a type="button" className="btn btn-link float-right theme" onClick={this.handleAddContactClick}
          tabIndex={0} role="link"
          aria-label={ formatMessage(messages.screenReader.addContactLink) }
        >
          <span className="fa-solid fa-circle-plus mr-1" aria-hidden="true"></span>
          <span className="hidden-xs"> <FormattedMessage {...messages.addContact} /></span>
        </a>
      </div>);
  };
}

AddContactButton.propTypes = {
  dispatch: PropTypes.func,
  intl: PropTypes.object,
};

export default connect()(injectIntl(AddContactButton));